import React from 'react';
import { Button, message } from 'antd';
import { connect } from 'react-redux';

import { addSubTitle, updateCategory } from './actions';
import AddCategoryModal from './add-category-modal';

class AddSubCategoryButton extends React.PureComponent{

	render(){
		return (
			<div>
				<Button onClick={this.handleOpenModal} shape="circle" icon="plus-circle" />
				
				<AddCategoryModal
					title={`Add a sub category for [${this.props.mainCategory.title}]`}

					handleCloseModal={this.handleCloseModal}
					handleConfirm={this.handleConfirmTitle}

					onChange={this.handleOnChange}
					onErrorHandler={this.handleError}
					value={this.state.subCategoryTitle}

					visible={this.state.openModal}/>
			</div>
		)
	}

	state = {
		openModal: false,
		subCategoryTitle: ""
	}

	handleCloseModal = () => {
		this.setState({
			subCategoryTitle:'',
			openModal: false
		})
	}

	handleConfirmTitle = () => {

		const { subCategoryTitle } = this.state;
		const { mainCategory } = this.props;

		if(!subCategoryTitle){
			return message.error("Empty Field is not allowed!");
		}

		if(this.state.error){
			message.error(`Can't save ${subCategoryTitle}`);
		} else {
			addSubTitle(mainCategory._id, subCategoryTitle)
				.then( res => {
					message.success(`${subCategoryTitle} was added successfully!`);
					this.props.dispatch( updateCategory(res.data) );
					this.handleCloseModal();
				})
				.catch( err => {
					message.error(err.response.data.message);
				})
		}
	}

	handleError = (error) => {
		this.setState({
			error
		})
	}

	handleOnChange = (e) => {
		this.setState({
			subCategoryTitle: e.target.value
		})
	}

	handleOpenModal = () => {
		this.setState({
			openModal: true
		})
	}


}

export default connect()(AddSubCategoryButton);


// WEBPACK FOOTER //
// ./src/components/category/add-sub-category-button.js